import React, { useState } from "react";
import { Col, Row, Select } from "antd";

import { dimensions } from "../stats/summary/dimensions";

const { Option } = Select;

const DimensionsSelect = props => {
  const allDimensions = [{ id: "global", label: "Global" }, ...dimensions];
  const [value, setValue] = useState("global");
  const selectedDimensions = ["global"];
  const getOptions = selectedDimensions => {
    const options = [];
    for (let i = 0; i < allDimensions.length - 1; i++) {
      const { id, label } = allDimensions[i];
      if (selectedDimensions.indexOf(id) === -1) {
        options.push(
          <Option key={i} value={id}>
            {label}
          </Option>
        );
      }
    }
    return options;
  };

  return (
    <Select
      size="default"
      mode="default"
      style={{ width: "50%" }}
      value={value}
      allowClear={false}
      placeholder={`Dimension ${props.order + 1}`}
      disabled={props.loading}
      onChange={data => {
        if (data) {
          selectedDimensions[props.order] = data;
        }
        props.onSelect(selectedDimensions);
        setValue(data);
      }}
    >
      {getOptions(dimensions)}
    </Select>
  );
};

const Dimensions = props => {
  let displayMaxOrder = props.hasOwnProperty("displayMaxOrder") ? props.displayMaxOrder : 3;

  const items = Array.from({ length: 4 }, (v, k) => k).map(k => ({
    id: `dimension-${k}`,
    order: k,
    content: dimensions[k]
  }));

  const col = 24 / (displayMaxOrder + 1);
  if (displayMaxOrder === 3) {
    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            {displayMaxOrder >= item["order"] && (
              <DimensionsSelect order={item["order"]} onSelect={props.onChange} {...props} />
            )}
          </div>
        ))}
      </div>
    );
  }

  return (
    <Row gutter={16}>
      <Col span={col}>
        {displayMaxOrder >= 0 && <DimensionsSelect onSelect={props.onChange} order={0} {...props} />}
      </Col>
      <Col span={col}>
        {displayMaxOrder >= 1 && <DimensionsSelect onSelect={props.onChange} order={1} {...props} />}
      </Col>
      <Col span={col}>
        {displayMaxOrder >= 2 && <DimensionsSelect onSelect={props.onChange} order={2} {...props} />}
      </Col>
      <Col span={col}>
        {displayMaxOrder >= 3 && <DimensionsSelect onSelect={props.onChange} order={3} {...props} />}
      </Col>
    </Row>
  );
};

export default Dimensions;



// WEBPACK FOOTER //
// src/modules/downloadstats/DimensionsDownload.js